import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { Subscription as RxJsSubscription } from 'rxjs';
import { ImageSearchParams } from '../../image-search-params';
import { Image } from '../../image';
import { Helpers } from '@app/shared';
@Component({
	selector: 'hpf-image-list',
	templateUrl: './image-list.component.html',
	styleUrls: [],
})
export class ImageListComponent implements OnInit, OnDestroy {
	/** The filters */
	searchParams = new ImageSearchParams(this.route.snapshot.queryParams);
	/** The search params subscription */
	private paramsSubscription: RxJsSubscription;
	/** Used to open or close filter drawer */
	filtersDrawer = false;
	/** Constructor */
	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private location: Location
	) {}
	/** Init */
	ngOnInit() {
		// Update query string when params change
		this.paramsSubscription = this.searchParams.subscribe(() => {
			this.location.replaceState(
				'/image',
				Helpers.toQueryString(this.searchParams.toObject())
			);
		});
	}
	/** Destroy */
	ngOnDestroy() {
		this.paramsSubscription.unsubscribe();
	}
	/** Called when the user select a row in the table */
	onSelect(item: Image) {
		this.router.navigateByUrl(`/image/${item.getId()}`);
	}
	onCreateBulk() {
		this.router.navigate(['/image/createbulk']);
	}
	/** Called when the user click on create */
	onCreate() {
		this.router.navigate(['/image/create']);
	}
}
